import {useEffect, useRef, useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useFocusEffect} from '@react-navigation/core';

export const useAutoFocus = ({
  mainInputHasFocus,
  isAnyPromptOpen,
  setFocusAction,
  delay,
}) => {
  const dispatch = useDispatch();
  const autoFocusTimerRef = useRef(null);
  const promptOpenRef = useRef(isAnyPromptOpen);
  promptOpenRef.current = isAnyPromptOpen;

  const clearAutoFocusTimer = () => {
    if (autoFocusTimerRef.current) {
      clearTimeout(autoFocusTimerRef.current);
      autoFocusTimerRef.current = null;
    }
  };

  useEffect(() => {
    if (!mainInputHasFocus && !isAnyPromptOpen) {
      clearAutoFocusTimer();
      autoFocusTimerRef.current = setTimeout(() => {
        if (!isAnyPromptOpen) {
          dispatch(setFocusAction(true));
        }
      }, delay);
    } else {
      clearAutoFocusTimer();
    }

    return clearAutoFocusTimer;
  }, [mainInputHasFocus, isAnyPromptOpen, delay]);

  useEffect(() => {
    const mountTimer = setTimeout(() => {
      if (!promptOpenRef.current && !mainInputHasFocus) {
        dispatch(setFocusAction(true));
      }
    }, 500);

    return () => clearTimeout(mountTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    shouldAutoFocus: !isAnyPromptOpen,
    isAnyPromptOpen,
  };
};

export const useNavigationFocus = (setFocusAction) => {
  const dispatch = useDispatch();

  useFocusEffect(
    useCallback(() => {
      dispatch(setFocusAction(false));

      const timer = setTimeout(() => {
        dispatch(setFocusAction(true));
      }, 10);

      return () => clearTimeout(timer);
    }, [dispatch, setFocusAction])
  );
};
